// Generated by packages/tokens/build.js — do not edit.
export const tokens = {
  "ru": {
    "color": {
      "brand": {
        "amarelo": "#EEAB1E",
        "amareloClaro": "#E9CB83",
        "verdeEscuro": "#5F9336",
        "verde": "#87C75F",
        "verdeClaro": "#BDE486",
        "azulEscuro": "#50A2C6",
        "azul": "#66C6F1",
        "azulClaro": "#B1E5EE",
        "vermelhoEscuro": "#9F1929",
        "vermelho": "#E33D5D",
        "vermelhoClaro": "#F47293",
        "cinzaEscuro": "#344348",
        "cinza": "#5F6F76",
        "cinzaClaro": "#B1CACE",
        "laranja": "#F46E21"
      },
      "surface": {
        "base": "#FFFDF8",
        "raised": "#FFFFFF",
        "muted": "#F5F0E8",
        "sunken": "#EBE3D5"
      },
      "text": {
        "default": "#1C1814",
        "muted": "#7A6E60",
        "inverse": "#FFFFFF"
      },
      "border": {
        "subtle": "#DDD5C4",
        "strong": "#B1CACE"
      },
      "semantic": {
        "primary": "#EEAB1E",
        "primaryContent": "#1A0E00",
        "secondary": "#87C75F",
        "secondaryContent": "#0D1A00",
        "accent": "#E33D5D",
        "accentContent": "#FFFFFF",
        "neutral": "#344348",
        "neutralContent": "#E8F0F3",
        "success": "#5F9336",
        "warning": "#EEAB1E",
        "error": "#9F1929",
        "info": "#50A2C6"
      },
      "day": {
        "segunda": "#EEAB1E",
        "terca": "#E33D5D",
        "quarta": "#66C6F1",
        "quinta": "#87C75F",
        "sexta": "#9F1929",
        "sabado": "#5F6F76",
        "domingo": "#344348"
      }
    },
    "font": {
      "family": {
        "ui": "Geist Variable, Geist, ui-sans-serif, system-ui, sans-serif",
        "legacyArtwork": "Trebuchet MS, Arial, sans-serif"
      },
      "weight": {
        "regular": 400,
        "medium": 500,
        "semibold": 600,
        "bold": 700
      },
      "size": {
        "xs": "12px",
        "sm": "14px",
        "md": "16px",
        "lg": "18px",
        "xl": "20px",
        "2xl": "24px",
        "3xl": "30px",
        "4xl": "36px",
        "5xl": "48px"
      },
      "lineHeight": {
        "tight": 1.15,
        "snug": 1.25,
        "normal": 1.5,
        "relaxed": 1.7
      }
    },
    "space": {
      "0": "0px",
      "1": "4px",
      "2": "8px",
      "3": "12px",
      "4": "16px",
      "5": "20px",
      "6": "24px",
      "8": "32px",
      "10": "40px",
      "12": "48px",
      "16": "64px",
      "20": "80px"
    },
    "radius": {
      "none": "0px",
      "sm": "4px",
      "md": "6px",
      "lg": "8px",
      "xl": "16px",
      "pill": "999px"
    },
    "layout": {
      "contentMaxWidth": "1120px",
      "pageGutter": "24px"
    },
    "shadow": {
      "sm": "0 1px 2px rgba(52, 67, 72, 0.10)",
      "md": "0 10px 30px rgba(52, 67, 72, 0.12)"
    },
    "motion": {
      "duration": {
        "fast": "150ms",
        "base": "200ms",
        "slow": "700ms"
      },
      "easing": {
        "standard": [
          0.22,
          1,
          0.36,
          1
        ]
      }
    }
  }
};
export default tokens;
